import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getTierCount } from '../../../../publicSession/selectors';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function useSubscriptionsItem() {
  const { t } = useTranslation();
  const tierCount = useSelector(getTierCount);
  const currentUser = useCurrentUser();
  const hasSubscriptions = tierCount > 0;
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const isMobile = useContext(MobileContext);

  const subscriptionsUrl = Url.userSubscriptionsLink({
    username: currentUser.username,
  });

  return (
    hasSubscriptions && {
      label: t('siteHeader.userMenu.mySubscriptions'),
      link: subscriptionsUrl,
      biData: BiData<TopNavMenuClickBiEvent>({
        evid: 702,
        link_url: subscriptionsUrl,
        menu_item: 'my_subscriptions',
        menu_name: 'profile',
      }),
      tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
    }
  );
}
